module.exports = __webpack_public_path__ + "img/ic_pin_yw.99cee710.svg";